import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from '@app/ui';
import FileUpload from '../FileUpload';
import CardImage from '../../components/posts/CardImageLegacy';
import sportsApi from '../../utils/sportsApi';
import { SPONSOR_LOGO } from '../../utils/s3Config';
const deleteSponsorLogo = async (sponsorId, logo) => {
    return sportsApi
        .url(`/sponsors/${sponsorId}/logos/${logo.logoId}`)
        .delete()
        .res();
};

const postSponsorLogo = async (sponsorId, file) => {
    const payloadData = {
        action: 'create',
        domainObject: {
            url: file.url,
        },
    };

    const sponsorLogos = await sportsApi
        .url(`/sponsors/${sponsorId}/logos`)
        .json(payloadData)
        .post()
        .json();

    return { ...sponsorLogos, fileId: file.id };
};

const SingleSponsor = ({ sponsor, fetchSponsors }) => {
    // const [showUploader, setShowUploader] = useState(false);
    const [files, setFiles] = useState([]);
    const [newSponsorLogos, setNewSponsorLogos] = useState([]);

    useEffect(() => {
        if (Array.isArray(files) && files.length > 0) {
            // eslint-disable-next-line wrap-iife
            (async function cleanUp() {
                const spLogos = await Promise.all(
                    files.map(f => postSponsorLogo(sponsor.id, f)),
                );
                await fetchSponsors();
                setNewSponsorLogos([...newSponsorLogos, ...spLogos]);
                setFiles([]);
            })();
        }
        return;
    }, [files]);

    const deleteLogo = async logo => {
        if (logo.logoId) {
            await deleteSponsorLogo(sponsor.id, logo);
            setTimeout(async () => await fetchSponsors(), 0);
        }
    };

    const hasLogos =
        files.length > 0 || (sponsor.logos && sponsor.logos.length > 0);

    return (
        <>
            <div className="gds-flex gds-flex--align-center gds-flex--justify-between -m-v-3">
                <p>{sponsor.name}</p>
            </div>

            {!hasLogos && (
                <p className="gds-text--body-sm gds-text--italic gds-text--danger -m-b-1 --sponsor-logo-message">
                    No logos found or uploaded for this sponsor
                </p>
            )}

            <Row gutter={16}>
                <Col md={24} className="-m-b-2">
                    <FileUpload
                        {...{
                            uploadType: SPONSOR_LOGO,
                            setFiles,
                            files,
                            metadata: { sponsorId: sponsor.id },
                            isReady: uploads =>
                                uploads.every(
                                    u =>
                                        newSponsorLogos.findIndex(
                                            f => u.id === f.id,
                                        ) > -1,
                                ),
                        }}
                    />
                </Col>

                {Array.isArray(sponsor.logos) &&
                    sponsor.logos.map((logo, index) => {
                        const { logoId, url } = logo;
                        return (
                            <Col key={`logo_${logoId}_${index}`} md={12}>
                                <Card data-test="sponsor-logo-onboarding">
                                    <CardImage
                                        url={url}
                                        hasMedia
                                        deleteMedia={() => deleteLogo(logo)}
                                    />
                                </Card>
                            </Col>
                        );
                    })}
            </Row>
        </>
    );
};

SingleSponsor.propTypes = {
    sponsor: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        logos: PropTypes.array,
    }),
    fetchSponsors: PropTypes.func,
};

export default SingleSponsor;
